/* eslint-disable no-shadow */
const HeaderText = 'Kuota Akses Bulanan Sudah Mencapai Limit';
const DescriptionText =
  'Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.';
const ButtonNewText = 'Buka Akses';
const ButtonContinueText = 'Lanjut Berlangganan';

export const PAYWALL_IMAGE_URL = '/img/paywall';
export const OfferingPro = {
  open: {
    title: 'Buka Rekening Saham',
    description:
      'Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.',
    iconUrl: `${PAYWALL_IMAGE_URL}/offering-open-icon.svg`,
  },
  subscribe: {
    title: 'Berlangganan',
    description:
      'Berlangganan mulai dari Rp15 ribu/hari untuk nikmati semua fitur tanpa batas.',
    iconUrl: `${PAYWALL_IMAGE_URL}/offering-subscribe-icon.svg`,
  },
};
export const OfferingProText = {
  headline: 'Nikmati Seluruh Fitur',
  underlined: 'Profesional Stockbit',
  unlimited: 'Tanpa Batas',
};

enum PaywallFeatureEnum {
  DEFAULT = 'PAYWALL_FEATURE_UNSPECIFIED',

  KEYSTATS = 'PAYWALL_FEATURE_KEYSTATS',
  ANALYST = 'PAYWALL_FEATURE_ANALYSIS',
  FINANCIALS = 'PAYWALL_FEATURE_FINANCIALS',
  FUNDACHART = 'PAYWALL_FEATURE_FUNDACHART',
  SEASONALITY = 'PAYWALL_FEATURE_SEASONALITY',
  CHARTBIT = 'PAYWALL_FEATURE_CHARTBIT',
  COMPARISON = 'PAYWALL_FEATURE_COMPARISON',
  INSIDER = 'PAYWALL_FEATURE_INSIDER',
  PROFILE = 'PAYWALL_FEATURE_COMPANY_PROFILE',
  CORPACTION = 'PAYWALL_FEATURE_CORP_ACTION',

  PRICE_ALERT = 'PAYWALL_FEATURE_PRICE_ALERT',
  RUNNING_TRADE = 'PAYWALL_FEATURE_RUNNING_TRADE',
  VALUATION = 'PAYWALL_FEATURE_VALUATION',
  BANDAR_DETECTOR = 'PAYWALL_FEATURE_BANDAR_DETECTOR',

  ORDERBOOK = 'PAYWALL_FEATURE_ORDERBOOK',
  SCREENER = 'PAYWALL_FEATURE_SCREENER',
  CALENDAR = 'PAYWALL_FEATURE_CALENDAR',
  EARNINGS = 'PAYWALL_FEATURE_EARNINGS',
}

enum CompanyWidgetEnum {
  FUNDACHART = 'FUNDACHART',
  SEASONALITY = 'SEASONALITY',
  COMPARISON = 'COMPARISON',
  FINANCIALS = 'FINANCIALS',
}

const IncludedNavbar = [
  'ORDERBOOK',
  'SCREENER',
  'VALUATION',
  'CALENDAR',
  'EARNINGS',
] as const;

const CompanyStreamWidget = ['ORDERBOOK', 'RUNNING_TRADE'] as const;

const CompanyWidgetTitle = {
  ORDERBOOK: 'Orderbook',
  RUNNING_TRADE: 'Running Trade',
  TRADE_BOOK: 'Trade Book',
  BROKER_SUMMARY: 'Broker Summary',
};

const AddOnWidget = 'VALUATION';

const ExcludeOldPro = ['analyst', 'insider', 'profile', 'corpaction'];
const ExcludeOldProPage = ['ORDERBOOK', 'CALENDAR', 'EARNINGS'];

export {
  HeaderText,
  DescriptionText,
  ButtonNewText,
  ButtonContinueText,
  PaywallFeatureEnum,
  CompanyWidgetEnum,
  IncludedNavbar,
  CompanyStreamWidget,
  CompanyWidgetTitle,
  AddOnWidget,
  ExcludeOldPro,
  ExcludeOldProPage,
};
